import { collection, doc, onSnapshot, runTransaction, serverTimestamp } from "firebase/firestore";
import { auth, db } from "../../../backend/firebaseConfig";
import { validateFeeStructure } from "./feeStructureModel";

const agreement = adviserId => doc(db, "Authorized Members", "Advisers", "Data", adviserId, "Client Agreement", "Data");
const root = adviserId => collection(agreement(adviserId), "Fee Structure Versions");
export const subscribeFeeStructures = (adviserIds, onValue, onError) => {
  const entries = new Map();
  if (!adviserIds.length) onValue([]);
  const stops = adviserIds.map(id => onSnapshot(root(id), s => {
    entries.set(id, s.docs.map(d => ({ ...d.data(), id: d.id, adviserId: id })));
    if (entries.size === adviserIds.length) onValue([...entries.values()].flat());
  }, onError));
  return () => stops.forEach(stop => stop());
};
// Immutable snapshots: edits append a revision, never update an earlier document.
// A transaction-backed version registry prevents concurrent duplicate version names.
export async function saveFeeStructure(adviserId, category, form, previousId = null) {
  if (!auth.currentUser || !adviserId) throw new Error("Sign in and select an adviser before saving.");
  const value = validateFeeStructure(form, category);
  const registry = agreement(adviserId);
  const target = doc(root(adviserId));
  await runTransaction(db, async transaction => {
    const current = await transaction.get(registry);
    const index = current.data()?.feeStructureIndex?.[category] || {};
    const versions = index.versions || [];
    if (versions.includes(value.version.toLowerCase())) throw new Error("This version already exists. Enter a new version to preserve its history.");
    if ((index.latestId || null) !== previousId) throw new Error("A newer version has been saved. Reload the latest details before saving.");
    transaction.set(target, { ...value, adviserId, category, previousId, createdAt: serverTimestamp(), updatedBy: auth.currentUser.email || "", updatedByName: auth.currentUser.displayName || auth.currentUser.email || "Unknown user" });
    transaction.set(registry, { feeStructureIndex: { [category]: { versions: [...versions, value.version.toLowerCase()], latestId: target.id } } }, { merge: true });
  });
}
